<div class="fontSize row mb-3" style="margin-top: 10px;">
  <div class="col-12 col-md-12 mt-1">
    <!-- <button type="button" class="btn btn-outline-primary btn-sm" [ngClass]="{'active' : isScreenshot}"
    (click)="showScreenshot()"><em class="fa fa-check" style="color: #aa00aa;"></em>&nbsp;{{"Screenshot" |
    translate}}
  </button>
  <button type="button" class="btn btn-outline-primary btn-sm mx-1" [ngClass]="{'active' : isDraft}"
    (click)="showScreenshotDraft()"><em class="fa fa-gear fa-spin" style="color: #0c92ff;"></em>&nbsp;
    Draft
  </button> -->


  <button type="button" class="btn btn-light" (click)="showScreenshot()"
    [ngStyle]="{ 'background-color': isScreenshot ? ' #c6c7c8' : '', }">
    <i class="fa fa-check" style="color: #aa00aa; margin-right: 5px;"></i>{{"Screenshot" |
  translate}}</button>
  <button type="button" class="btn btn-light" (click)="showScreenshotDraft()"
    [ngStyle]="{ 'background-color': isDraft ? ' #c6c7c8' : '' }"><em class="fa fa-gear fa-spin"
  style="color: #12c9e9;"></em>&nbsp;
{{"Draft" | translate}}</button>

</div>
<!-- <div class="row mb-3">
<div class="col-md-12 mt-1" style="display: flex;">

</div>
</div> -->
</div>

<!-- Screenshot Section -->
@if (isScreenshot) {
  <div class="fontSize">
    <div class="col-12 col-md-12 widget-container fluid-height">
      <div class="col-12 col-md-12 stf-screenshots">
        <div class="row mt-2">
          <div class="col-8 col-md-8">
            <button class="btn btn-sm btn-outline-primary" (click)="takeScreenShot()" title="Take Screenshot">
              <i class="fa fa-camera"></i><span>{{" Screenshot" | translate}}</span>
            </button>
            @if (screenshots.length > 0) {
              <button class="btn btn-sm btn-primary" style="margin-left: 15px;"
                (click)="downloadScreeshot()" title="Save">
                <i class="fa fa-download"></i><span>{{"Save All" | translate}}</span>
              </button>
            }
            @if (screenshots.length!=0) {
              <button class="m-2 btn btn-danger btn-sm"
                (click)="removeAllScreenshots()" title="Delete All Screenshots">
                {{"Discard All" | translate}}
              </button>
            }
          </div>
          <div class="col-4 col-md-4">
            <div class="pull-right">
              @if (device.platform == 'iOS' || device.platform == 'Android') {
                <input type="range" [(ngModel)]="value" id="test" min="0" max="100" step="10"
                  (click)="resizeImageOfIos({ max: 100, step: 1 })" [disabled]="screenshots.length == 0"
                  class="zoom-range">
              }
            </div>
          </div>
        </div>
        <div class="widget-content padded">
          @if (screenshots.length == 0) {
            <div>
              <div class="nothing-to-show">
                <i class="fa fa-4x fa-camera" ng-class="icon"></i>
                <p>{{ "No screenshot taken" | translate }}</p>
                <span class="helper-text">{{"Click the " | translate}}<strong>{{"Screenshot" | translate}}</strong>{{" button to capture your first screenshot!" | translate}}</span>
              </div>
            </div>
          }
          <ul class="screenshots-icon-view clear-fix selectable">
            @for (shot of screenshots; track shot; let i = $index) {
              <li class="screenshots-icon-item">
                <br />
                <h5>{{ device.serial }}</h5>
                <h6>{{ shot.body.date | date:'HH:mm:ss' }}</h6>
                <a class="fa fa-save" style="font-size: 20px" target="_blank" [href]="shot.body.href"
                download="screenshot.png" title="Save as backup"></a>&nbsp;
                <a class="fa fa-trash" style="font-size: 20px; color: red" (click)="removeScreenShot(i)"
                title="Delete"></a>
                <a [href]="shot.body.href" target="_blank" download="screenshot.png">
                  <img class="screenshot-image resizeIOS"
                    src="{{ shot.body.href + shotSizeParameter(480, 1) }}"
                    srcset="{{ shot.body.href + shotSizeParameter(480, 2) }} 2x" />
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
}

<!-- Draft Screenshot section -->
@if (isDraft) {
  <div class="fontSize">
    <div class="col-12 col-md-12 widget-container fluid-height">
      <div class="stf-screenshots">
        <div class="row">
          <div class="col-4 col-md-4">
            <button class="btn btn-sm btn-primary" (click)="backupScreenshot()"
              title="{{'Backup Screenshot' | translate}}">
              <i class="fa fa-folder"></i>
              <span>&nbsp;{{"Backup Screenshot" | translate}}</span>
            </button>
          </div>
          <div class="col-8 col-md-8">
            @if (newArray.length > 0) {
              <a class="btn btn-sm btn-outline-primary" (click)="DraftScreeshot()"
                title="Save">
                <i class="fa fa-download"></i>
                <span>&nbsp;{{"Save All" | translate}}</span>
              </a>
            }
            @if (newArray.length > 0) {
              <a class="btn btn-sm btn-outline-primary" style="margin-left: 15px;"
                (click)="downloadSSasPDFScreenshot()" title="Save">
                <i class="fa fa-download"></i>
                <span>&nbsp;{{"Save All As PDF" | translate}}</span>
              </a>
            }
            @if (newArray.length > 0) {
              <button class="btn btn-sm btn-outline-danger" style="margin-left: 15px;"
                (click)="draftAllDeleteScreenshot()" title="Discard">
                <i class="fa fa-trash"></i>
                <span>&nbsp;{{"Discard All" | translate}}</span>
              </button>
            }
          </div>
        </div>
        <div class="widget-content padded">
          @if (newArray.length == 0) {
            <div>
              <div class="nothing-to-show">
                <i class="fa fa-4x fa-camera"></i>
                <p>{{"No screenshots taken" | translate}}</p>
              </div>
            </div>
          }
          <ul class="screenshots-icon-view clear-fix selectable">
            @for (shot of newArray; track shot; let i = $index) {
              <li class="screenshots-icon-item">
                <h5>{{ device.name }}</h5>
                <a class="fa fa-save" style="font-size:20px" target="_blank" [href]="shot"
                download="screenshot.png"></a>
                <a class="fa fa-trash" style="font-size:20px" color="red"
                (click)="removeDraftScreenShot(i)"></a>&nbsp;
                <a [href]="shot" target="_blank" download="screenshot.png"></a>
                <img class="stf-screenshots-size" [src]="shot" />
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
}

<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #alerttemplate2 let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Yes()">{{"Yes" | translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="No()">{{"No" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #downloadAllScreenshot let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to Download all Screenshot" | translate}}</p>
    <div class="alert-actions">
      <button style="display: inline;" type="button" class="btn btn-success" (click)="downloadAllScreeshot();">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button style="display: inline" type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #DownloadDraftScreeshot let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to Download all Screenshot" | translate}}</p>
    <div class="alert-actions">
      <button style="display: inline;" type="button" class="btn btn-success" (click)="downloadDraftScreeshot();">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button style="display: inline" type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #draftClearScreeshot let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to Delete All Screenshot" | translate}}</p>
    <div class="alert-actions">
      <button style="display: inline;" type="button" class="btn btn-success" (click)="draftClear();">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button style="display: inline" type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #DownloadAsPdfScreeshot let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to Download all Screenshot as Pdf?" | translate}}</p>
    <div class="alert-actions">
      <button style="display: inline;" type="button" class="btn btn-success" (click)="downloadSSasPDF();">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button style="display: inline" type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>